var React = require("react");
var createClass= require("create-react-class");

React.createClass = createClass;

if (!React.DOM) {
	React.DOM = {};

	[
		"div", "button", "img", "span", "br", "input", "h1", "p", "select", "option",
		"table", "tr", "td", "th", "ul", "li", "a", "hr", "form", "label", "svg", "path", "defs",
		"textarea",
	].forEach(function(element){
		React.DOM[element] = React.createFactory(element)
	});
}

module.exports = React;
